import { convertToEditableCondition } from './convertToEditableCondition';
import { createBlankRequirement } from './createBlankRequirement';
import { CompleteRequirement, EditableRequirement } from '../types';
import { parseForInBetweenDates } from './inBetweenComparatorHelpers';

/** converts CompleteRequirement to EditableReqirement */
export const convertToEditableRequirement = (
  requirement: CompleteRequirement,
): EditableRequirement =>
  createBlankRequirement({
    ...requirement,
    searchCombo: {
      combinator: requirement.searchCombo.combinator,
      searchQueries: parseForInBetweenDates(requirement.searchCombo.searchQueries).map(
        convertToEditableCondition,
      ),
    },
  });
